const API_BASE_URL = (process.env.REACT_APP_API_BASE_URL || "").replace(/\/+$/, "");

export const buildApiUrl = (path) => {
  const normalizedPath = path.startsWith("/") ? path : `/${path}`;
  return `${API_BASE_URL}${normalizedPath}`;
};

export const buildApiFetchOptions = (options = {}) => {
  return {
    cache: "no-cache",
    credentials: "include",
    ...options,
    headers: {
      ...(options.headers || {}),
    },
  };
};

export const apiFetch = (path, options = {}) => {
  return fetch(buildApiUrl(path), buildApiFetchOptions(options));
};

export default API_BASE_URL;
